import './style.scss'

export const NeedCard = () => {
  return (
    <div className="need-card">
      <h3 className="need-card__title">Заполните данные в профиле</h3>

      <p className="need-card__desc">Чтобы вызвать такси, заполните информацию в профиле!</p>
    </div>
  )
}
